import { useTranslation } from 'react-i18next'

const LivingRoom3 = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="livingroom3-title"
      {...props}
    >
      <title id="livingroom3-title">{t('antagonists:bigsister:components:background')}</title>
      <defs>
        <clipPath id="livingroom3-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#livingroom3-a)',
        }}
      >
        <path
          style={{
            fill: '#dedbe9',
          }}
          d="M-103.91-87.7H1928.4v1132.89H-103.91z"
        />
        <path
          style={{
            fill: '#f1f1f3',
          }}
          d="m1349.27 852.52 5.27-780.62 383.09 2.07 6.45 779.6-394.81-1.05z"
        />
        <path
          style={{
            fill: '#f3f3f4',
          }}
          d="M-196.65 829.87H1943v773.49H-196.65z"
        />
        <path
          style={{
            fill: '#6d838e',
          }}
          d="m567.43 644.42-70.8-5.31 3.97-52.94-168.98 7.48 5.52 46.78-67.99 5.32-.92 10.89 299.94-.37-.74-11.85z"
        />
        <path
          style={{
            fill: '#6d838e',
          }}
          d="M167.86 264.05 167.27 615l499.07 2.98-1.52-352.27-496.96-1.66z"
        />
        <path
          style={{
            fill: '#131f2b',
          }}
          d="m182.14 276.54 1 324.22 468.31 3.84-1.82-326.75-467.49-1.31z"
        />
        <path
          style={{
            fill: '#99793e',
          }}
          d="m768.31 548.62-.51 33.14h7.14l-.51-33.65-6.12.51z"
        />
        <path
          style={{
            fill: '#fee608',
          }}
          d="m716.07 429.42-18.58 129.09 145.8 1.53-21.01-132.36-106.21 1.74z"
        />
        <path
          style={{
            fill: '#497125',
          }}
          d="m747.72 579.61.07 137.62 46.87-.91.08-137-47.02.29z"
        />
        <path
          style={{
            fill: '#00232c',
          }}
          d="m670.01 746.33.93 36.67 117.26-1.27-.98-36.68-117.21 1.28z"
        />
        <path
          d="M758.45 763.99c0 1.6.84 3.26 3.24 3.43 2.4.17 3.93-1.42 3.85-3.47-.07-1.91-1.37-3.28-3.73-3.26-2.21.02-3.36 1.61-3.36 3.3Zm11.5-.32c0 1.6.84 3.26 3.24 3.43 2.4.17 3.93-1.42 3.85-3.47-.07-1.91-1.37-3.28-3.73-3.26-2.21.02-3.36 1.61-3.36 3.3Z"
          style={{
            fill: '#4f4e47',
          }}
        />
        <path
          style={{
            fill: '#5a5099',
          }}
          d="m677.63 759.72.69 9.28 55.37-.66.72-10.06-56.78 1.44z"
        />
        <path
          style={{
            fill: '#e2a972',
          }}
          d="m1387.83 103.95 317.98 1.16 5.42 766.14-329.14.73 5.74-768.03z"
        />
        <path
          style={{
            fill: '#c4c7c9',
          }}
          d="m1412.77 465.52.3 65.19 25.98-.46-1.21-65.65-25.07.92z"
        />
        <path
          style={{
            fill: '#009250',
          }}
          d="m1420.36 478.28 61 1.03-.86 8.63-60.14 4.9v-14.56z"
        />
        <path
          d="M1415.39 513.68c0 3.8 1.99 7.74 7.68 8.15 5.7.41 9.32-3.37 9.13-8.24-.17-4.52-3.26-7.79-8.85-7.73-5.24.06-7.96 3.82-7.96 7.82Z"
          style={{
            fill: '#f5f2ed',
          }}
        />
        <path
          d="m1425.83 508.01-7.12 9.18 2.81 1.78 7.44-9s-3.41-1.87-3.13-1.96Z"
          style={{
            fill: '#1a4431',
          }}
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#e4c795',
          }}
          d="M-188.3 853.47h2139.65v773.49H-188.3z"
        />
        <path
          d="m124.73 862.42 1.75-204.12 695.59-1.75 2.37 204.16h-19.82l-2.71-55.23-655.29-2.63-1.82 59.02-20.08.55Zm23.65-122.94v40.3l325.02-3.5v-38.55l-325.02 1.75Zm341.49-2.22 1.17 41.97 305.63 1.43v-44.68l-306.79 1.28Z"
          style={{
            fill: '#f1f1f3',
          }}
        />
        <path
          style={{
            fill: '#00658b',
          }}
          d="m911.23 436.3 2.85 22.81 193.47-.36 3.57-22.09-199.89-.36z"
        />
        <path
          style={{
            fill: '#00658b',
          }}
          d="m926.19 453.05 21.38 195.26 7.48-.36-21.73-194.9h-7.13zm27.44-3.21 11.04 196.68 6.42-1.07-10.69-194.89-6.77-.72zm27.43 3.92 4.64 200.25 7.12.35-4.63-200.95-7.13.35zm27.44-2.49-.36 193.12h6.06l.71-189.56-6.41-3.56z"
        />
        <path
          d="M909.1 656.81c-.42 2.75 0 7.89 0 7.89h202.74s.44-3.86.02-6.83.42-5.72-7.84-8.47c-8.26-2.75-17.18-4.97-25.21-5.51-6.36-.42-48.09-1.91-67.37-1.69-19.28.21-63.56 1.48-70.34 1.91-5.51.34-15.47 2.33-20.13 4.45-3.48 1.58-11.44 5.51-11.86 8.26Z"
          style={{
            fill: '#00658b',
          }}
        />
        <path
          d="M935.49 655.13s-20.98 111.9-22.92 129.39c-1.94 17.48-11.27 87.81-11.27 87.81l12.05-.39s17.1-78.49 19.04-110.74c1.94-32.25 13.21-102.19 13.21-102.19l-10.1-3.89Z"
          style={{
            fill: '#00658b',
          }}
        />
        <path
          d="M921.49 763.08s51.3-1.09 84.71-2.26c33.42-1.17 92.47 3.11 92.47 3.11l.62 9.03s-62.37 5.72-91.98 4.94c-31.91-.84-87.05-4.94-87.05-4.94l1.23-9.88Z"
          style={{
            fill: '#00658b',
          }}
        />
        <path
          d="M1084.49 657.06s23.6 111.38 25.96 128.81c2.35 17.43 13.33 87.52 13.33 87.52l-12.05-.11s-18.93-78.06-21.63-110.26-15.61-101.85-15.61-101.85l10.01-4.12Zm11.99-206.12-21.38 195.25-7.48-.35 21.74-194.9h7.12zm-27.43-3.21L1058 644.41l-6.41-1.07 10.69-194.9 6.77-.71zm-27.44 3.92-4.63 200.24-7.13.36 4.63-200.96 7.13.36z"
          style={{
            fill: '#00658b',
          }}
        />
      </g>
    </svg>
  )
}

export default LivingRoom3
